import React from 'react';

import TopView from '@/components/BlogSharedHeader/components/Top/TopView';
import { BreadCrumbType } from '@/typings/common';

type Props = {
  pageTitle: string;
  breadCrumbList: BreadCrumbType[];
};

const Top = ({ pageTitle, breadCrumbList }: Props) => {
  return <TopView breadCrumbs={breadCrumbList} pageTitle={pageTitle} />;
};

export default Top;
